import { initFederation } from '@angular-architects/native-federation';

import { markItemManagerRemoteReady } from './federation-state';
import { environment } from './environments/environment';
import { bootstrapPortal } from './item-manager-federation-bootstrap';
import { loadRuntimeConfig } from './runtime-config';

void bootstrapPortal({
  itemManagerRemoteEntry: environment.itemManagerRemoteEntry,
  buildTimeLegacyRoutesEnabled: environment.itemManagementLegacyRoutes,
  loadRuntimeConfig,
  initFederation,
  markItemManagerRemoteReady,
  importBootstrap: () => import('./bootstrap'),
  warn: (message) => console.warn(message),
  error: (error) => console.error(error),
}).catch((error) => console.error(error));
